module.exports = __webpack_public_path__ + "img/eletrodutoAcessorioTampao2.b6381111.png";